// extracted by css-extract-rspack-plugin
export default {"focus":"Theme-module__focus___QSUlZ"};